import React, { useState } from 'react';
import { Stack } from '@mui/material';
import { Check, FileCopy } from '@mui/icons-material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { sanitizeApiKey } from 'js/lib/URLUtils';
import { IconButton } from 'new/elements/IconButton/IconButton';
import { useGetServiceKeys } from 'new/components/settings/Authentication/ServiceKeys/useGetServiceKeys';
import { SdkApplication } from '@nexla/@types';
import styles from './ServiceKeysCell.module.scss';

type Props = {
  app: SdkApplication;
};

function KeyRow({ apiKey }: { apiKey: string }) {
  const [copied, setCopied] = useState(false);

  const onCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Stack flexDirection="row" alignItems="center" gap="4px" minWidth={0} overflow="hidden">
      <span className={styles.keyText}>{sanitizeApiKey(apiKey)}</span>
      <CopyToClipboard text={apiKey} onCopy={onCopy}>
        <IconButton aria-label="Copy Service Key" color="primary" className={styles.copyButton}>
          {copied ? <Check fontSize="small" /> : <FileCopy fontSize="small" />}
        </IconButton>
      </CopyToClipboard>
    </Stack>
  );
}

export function ServiceKeysCell({ app }: Props) {
  const allServiceKeys = useGetServiceKeys();
  const linked = (allServiceKeys ?? []).filter((key) => key?.sdk_application_id === app.id);

  if (linked.length === 0) {
    return <span className={styles.emptyState}>—</span>;
  }

  return (
    <Stack flexDirection="column" gap="4px" width="100%">
      {linked.map((key) => (
        <KeyRow key={key.id} apiKey={key.api_key} />
      ))}
    </Stack>
  );
}
